export default __webpack_public_path__ + "static/media/seven.1e153dce.jpeg";